import { Ability, AbilityBuilder } from '@casl/ability';
import { Actions, features, permissions, Subjects } from './permissionsAndFeatures';

type AppAbility = Ability<[Actions, Subjects]>;

export function defineAbilityFor(account: Account): AppAbility {
  const { can, rules } = new AbilityBuilder<AppAbility>(Ability);
  features.forEach(feature => {
    if (!account || !account.customer) {
      return false;
    }
    const hasFeature = account.customer.features?.findIndex(f => f.feature.toLowerCase() === feature.name.toLowerCase()) > -1 ?? false;
    if (hasFeature) {
      can(feature.can, feature.resource);
    }
  });

  permissions.forEach(permission => {
    const hasPermission =
      account?.effectiveCustomerPermissions?.findIndex(p => p.permission.toLowerCase() === permission.name.toLowerCase()) > -1 ?? false;
    if (hasPermission) {
      can(permission.can, permission.resource);
    }
  });

  return new Ability<[Actions, Subjects]>(rules);
}
